import { useEffect } from "react";
import { getStorageString, saveStringStorage, STORAGE_APP_VERSION } from "../services/storage";

const localVersion = __APP_VERSION__;

export function useCheckVersion() {
	const storageAppVersion = getStorageString(STORAGE_APP_VERSION);

	useEffect(() => {
		if (!storageAppVersion) {
			saveStringStorage(STORAGE_APP_VERSION, localVersion);
			return;
		}

		const checkVersion = async () => {
			try {
				const response = await fetch("/version.json", {
					cache: "no-store",
				});
				const data = await response.json();
				const remoteVersion = data.version;

				if (remoteVersion !== storageAppVersion) {
					console.warn(`New version detected! Local: ${storageAppVersion}, Remote: ${remoteVersion}`);

					saveStringStorage(STORAGE_APP_VERSION, remoteVersion);
					await clearAppCache();
					window.location.reload();
				}
			} catch (error) {
				console.error("Error fetching version.json:", error);
			}
		};

		checkVersion();
	}, [storageAppVersion]);

	async function clearAppCache() {
		if ("caches" in window) {
			try {
				const names = await caches.keys();
				await Promise.all(names.map((name) => caches.delete(name)));
				console.log("Service Worker caches successfully cleared");
			} catch (err) {
				console.warn("Error clearing caches:", err);
			}
		}

		if ("serviceWorker" in navigator) {
			const registrations = await navigator.serviceWorker.getRegistrations();
			for (const registration of registrations) {
				registration.unregister().then((success) => {
					if (success) {
						console.log("Service Worker removed");
					}
				});
			}
		}
	}
}
